import { createUseStyles } from "react-jss";

export const useStyles = createUseStyles({
  teamsLayout: {
    height: "100vh",
    width: "100vw",
    display: "flex",
    color: "var(--primary-foreground)",
    justifyContent: "center",
    alignItems: "center",
  },
});
